import { LoadState } from "../../constants/enums";
import { IFeeTransition, IStudent, IStudentState } from "./student.types";

// export const initialCustomerState: ICustomer = {
//   personalInformation: {
//     data: {
//       customer_personal_information_id: 0,
//       customer_id: 0,
//       salutation: "",
//       first_name: "",
//       last_name: "",
//       goes_by: "",
//       position: "",
//       mobile: "",
//       phone: "",
//       phone_ext: "",
//       email: "",
//       status: "ACTIVE",
//       insert_ts: "",
//     },
//     loading: LoadState.NotLoaded,
//   },
//   customerProspect: {
//     data: {
//       customer_prospect_details_id: 0,
//       customer_id: 0,
//       customer_name: "",
//       csr: "",
//       customer_code: "",
//       form_of_business: "",
//       tax_zone: "ON",
//       mailing_address: "",
//       language: "E",
//       producer: "",
//       marketer: "",
//       branch: "",
//       assigned_to: null,
//       status: "ACTIVE",
//       insert_ts: "",
//       city: "",
//       province_or_state: "",
//       country: "",
//       postal_code: "",
//       unit_or_suite: "",
//     },
//     loading: LoadState.NotLoaded,
//   },
//   customerSocial: {
//     data: {
//       customer_social_id: 0,
//       customer_id: 0,
//       website: "",
//       facebook: "",
//       linkedin: "",
//       status: "ACTIVE",
//       insert_ts: "",
//     },
//     loading: LoadState.NotLoaded,
//   },
//   customerRelatedAccount: {
//     data: {
//       customer_related_account_id: "",
//       customer_id: "",
//       cross_reference_id: "",
//       status: "ACTIVE",
//       name: "",
//       insert_ts: "",
//     },
//     loading: LoadState.NotLoaded,
//   },
//   customerConsent: {
//     data: {
//       incremental_number: 0,
//       customer_id: "",
//       privacy_consent: "",
//       privacy_act_consent: "",
//       anti_spam_consent: "",
//       telematics_consent_code: "",
//       status: "ACTIVE",
//       insert_ts: "",
//     },
//     loading: LoadState.NotLoaded,
//   },
//   opportunity: {
//     data: [],
//     totalRecords: 0,
//     loading: LoadState.NotLoaded,
//   },
//   customerConsentList: {
//     data: [],
//     loading: LoadState.NotLoaded,
//   },
//   customerGroupsList: {
//     data: [],
//     loading: LoadState.NotLoaded,
//   },
//   customerFullDetails: {
//     loading: LoadState.NotLoaded,
//   },
//   customerContacts: {
//     data: [],
//     loading: LoadState.NotLoaded,
//   },

//   error: "",
// };

export const defaultFeeTransaction: IFeeTransition = {
	fee_transaction_id: 0,
	fee_transaction_unique_id: 0,
	fee_transaction_uuid: "",
	opportunity_uuid: "",
	customer_fact_uuid: null,
	customer_name: null,
	fees_paid: 0,
	remarks: null,
	created_by_uuid: "",
	created_by_name: "",
	modified_by_uuid: "",
	modified_by_name: "",
	create_ts: "",
	insert_ts: "",
};

export const defaultStudent: IStudent = {
	contact_number: "",
	customer_code: "",
	customer_personal_information_id: 0,
	customer_personal_information_unique_id: 0,
	customer_personal_information_uuid: "",
	customer_fact_uuid: "",
	representative_email: "",
	representative_contact: "",
	representative_name: "",
	event_type: "",
	salutation: null,
	customer_name: "",
	goes_by: "",
	company_name: "",
	leads_email: "",
	deal_type: "",
	live_date: "",
	api_integration: "",
	signatory_remark: "",
	position: null,
	mobile: null,
	contact_number_1: "",
	contact_number_2: null,
	phone_ext: null,
	email: "",
	status: "ACTIVE",
	created_by_uuid: "",
	created_by_name: "",
	modified_by_uuid: "",
	modified_by_name: "",
	create_ts: "",
	insert_ts: "",
	assigned_to: null,
	docs_upload: null,
  
	// Missing values added with null
	inquiry_date: null,
	name_of_guest: "",
	last_name: null,
	date_of_birth: null,
	gender: null,
	permanent_address: null,
	caste_category: null,
	city: null,
	state: null,
	pincode: null,
	country: null,
	inquiry_reference: null,
	followUp_date_and_remark: null,
	father_name: null,
	mother_name: null,
	annual_income: null,
	package_structure: null,
	family_income: null,
	aadhar_no: null,
	remarks: "",
  };
  

export const defaultStudentState: IStudentState = {
	list: {
		data: [],
		totalRecords: 0,
		loading: LoadState.NotLoaded,
		error: null,
	},
	student: {
		data: defaultStudent,
		loading: LoadState.NotLoaded,
		error: null,
	},
	feeTransitionlist: {
		data: [],
		totalRecords: 0,
		loading: LoadState.NotLoaded,
		error: null,
	},
	feeTransition: {
		data: defaultFeeTransaction,
		loading: LoadState.NotLoaded,
		error: null,
	},
};
